const ClassFunc = require('../../util/ClassFunc')
const Common = require('./Common')
const Staff = require('../to/Staff')

const staff = new Staff
/**
 * The Staff class acts as the view object for the staff.
 */
const tbs_model_vo_Staff = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Common, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_Staff.prototype = {
    /* The view object name */
    name: 'staff',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetCrmAccountContactList',
            query: {
                accountId: 'organizationId'
            },
            basePath: 'data.list',
            rule: {
                id: 'id',
                name: 'name',
                logoUrl: 'avatar',
                role: '$roleIds',
                roleLabel: '$roleIds',
                remark: 'remark',
                isLogon: '@userId',
                isSuperAdmin: '$roleIds',
                firstLetter: '$nameInitials',
            }
        },
        fetch: {
            method: 'get',
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'getCrmAccountContact',
            basePath: 'data.contact',
            rule: {
                id: 'id',
                organizationId: 'accountId',
                name: 'name',
                isSuperAdmin: '$roleIds',
                roleList: '$roleIds',
                remark: 'remark',
            }
        },
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'getCrmAccountContact',
            basePath: 'data.contact',
            rule: {
                id: 'id',
                organizationId: 'accountId',
                name: 'name',
                isSuperAdmin: '$roleIds',
                roleLabel: '$roleIds',
                remark: 'remark',
                isLogon: '@userId',
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'CreateCrmAccountContact',
            basePath: '',
            rule: {
                accountId: '$organizationId',
                name: 'name',
                roleIds: '$roleList,isSuperAdmin',
                remark: 'remark'
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'UpdateCrmAccountContact',
            basePath: '',
            rule: {
                id: 'id',
                name: 'name',
                roleIds: '$roleList,isSuperAdmin',
                remark: 'remark'
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'UpdateCrmAccountContactStatus',
            basePath: '',
            rule: {
                id: 'id',
                status: '(-2)'
            }
        },
        send: {
            method: 'get',
            baseUrl: process.env.VUE_APP_PASS_API,
            apiPrefix: '/api/',
            service: 'CreateMatchOrganizationManagerInvitation.json',
            query: {
                contactId: 'staffId',
                orgId: 'organizationId'
            },
            basePath: 'data',
            rule: {
                organizationName: 'orgName',
                organizationLogoUrl: 'orgLogo',
                ticket: 'ticket',
            }
        },
        invite: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetMatchOrganizationManagerInvitationInfo2',
            method: 'get',
            basePath: 'data.info',
            rule: {
                name: 'contactName',
                organizationName: 'orgName',
                organizationLogoUrl: 'orgLogo',
                roleLabel: '$roleIds',
                organizationEntyYear: '$createDate'
            }
        },
        accept: {
            baseUrl: process.env.VUE_APP_PASS_API,
            apiPrefix: '/api/',
            service: 'AcceptMatchOrganizationManagerInvitation.json',
            basePath: '',
            rule: {
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderRoleList: function(roleIds) {
        const roleIdList = roleIds.split(',')
        if (roleIdList.indexOf('1') > -1) {
            roleIdList.splice(roleIdList.indexOf('1'), 1)
        }
        return roleIdList
    },
    renderIsSuperAdmin: function(roleIds) {
        const roleList = roleIds.split(',')
        if (roleList.indexOf('1') > -1) {
            return true
        }
        return false
    },
    formatAccountId: function(organizationId, options) {
        return options.organizationId
    },
    renderOrganizationEntyYear: function(createDate) {
        return createDate.substr(0, 4)
    },
    renderMatchList: function(matchList) {
        const convertedMatchList = []
        for (let i = 0; i < matchList.length; i++) {
            let match = matchList[i]
            convertedMatchList.push({
                matchId: match.id
            })
        }
        return convertedMatchList
    },
    formatRoleIds: function(roleList, isSuperAdmin) {
        if (isSuperAdmin) {
            return '1'
        }
        else {
            return roleList.join(',')
        }
    },
    renderFirstLetter: function(nameInitials) {
        return nameInitials ? nameInitials.substr(0, 1) : ''
    },
    renderRoleLabel: function(roleIds) {
        const roleLabels = []
        const roleList = roleIds.split(',')
        for (let i = 0; i < roleList.length; i++) {
            let roleId = roleList[i]
            roleLabels.push(staff.localeProp('role-option-' + roleId))
        }
        return roleLabels.join(staff.localeProp('comma'))
    },
    getRoleOptions: function() {
        return [
            { label: staff.localeProp('role-option-2'), value: '2'},
            { label: staff.localeProp('role-option-3'), value: '3'},
            { label: staff.localeProp('role-option-4'), value: '4'},
            { label: staff.localeProp('role-option-6'), value: '6'},
            { label: staff.localeProp('role-option-9'), value: '9'},
        ]
    },
    localeProp: function(key, params) {
        return staff.localeProp(key, params)
    }
}

//--------------------------------------------------
// extends the Common
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_Staff, Common);

module.exports = tbs_model_vo_Staff